import {
  getData,
  saveData
} from '@/api/local_storage'

let caseLocalKay = 'ele_case'

export const saveEleCase = function (caseData) {
  let allData = getEleCase() || []
  allData.push(caseData)
  saveData({key: caseLocalKay, data: allData})
}

export const clearEleCase = function (caseName) {
  let allData = getEleCase() || []
  let newData = []
  allData.forEach(function (item) {
    if (item.name !== caseName) {
      newData.push(item)
    }
  })
  saveData({key: caseLocalKay, data: newData})
}

export const getEleCase = function (nameList) {
  let data = []
  let allData = getData(caseLocalKay)
  if (nameList) {
    allData.forEach(function (item) {
      if (nameList.indexOf(item.name) > -1) {
        data.push(item)
      }
    })
  } else {
    data = allData
  }
  return data
}



// WEBPACK FOOTER //
// ./src/api/ele_local.js